import { Alert } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { availableFrom, availableTo } from '@app/configs/dateTime';
import { mapLithuanianToLocalTime } from '@app/utils/time';
const TimeRemaining = ({ onDismiss }) => {
    const { t } = useTranslation();
    const from = mapLithuanianToLocalTime(availableFrom);
    const to = mapLithuanianToLocalTime(availableTo);
    return (<Alert title={t('financing.time_remaining.title')} variant="warning" onClose={onDismiss}>
            <div className="body-m">{t('financing.time_remaining.message', { from, to })}</div>
        </Alert>);
};
export default TimeRemaining;
